import { type FunctionComponent } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy.js';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { Button } from 'dibs-elements/exports/Button.tsx';
import { type RelatedQuestions_question$data } from './__generated__/RelatedQuestions_question.graphql.ts';
import styles from './relatedQuestions.scss';

type Props = {
    question: RelatedQuestions_question$data;
};

const RelatedQuestionsComponent: FunctionComponent<Props> = ({ question }) => {
    const relatedQuestions = question?.relatedQuestions || [];
    if (relatedQuestions.length) {
        return (
            <div className={styles.wrapper}>
                <div className={styles.divider} />
                <div className={styles.relatedQuestionsHeader} data-tn="related-questions">
                    <FormattedMessage
                        id="questionsAnswers.relatedQuestionsTitle"
                        defaultMessage="Related Questions"
                    />
                </div>
                <ul className={styles.relatedQuestions}>
                    {relatedQuestions.map(relatedQuestion => {
                        if (relatedQuestion) {
                            const { title, url, answerCount } = relatedQuestion;
                            if (title && url && answerCount && answerCount > 0) {
                                return (
                                    <li key={url} className={styles.relatedQuestion}>
                                        <Link
                                            className={styles.relatedQuestionLink}
                                            href={url}
                                            dataTn="related-questions-link"
                                        >
                                            <div className={styles.relatedQuestionTitle}>
                                                {title}
                                            </div>
                                            <div className={styles.answerCount}>
                                                <FormattedMessage
                                                    id="RelatedQuestions.answerCount"
                                                    defaultMessage="{answerCount, plural, one {# Answer} other {# Answers}}"
                                                    values={{ answerCount }}
                                                />
                                            </div>
                                        </Link>
                                    </li>
                                );
                            }
                        }

                        return null;
                    })}
                </ul>
                <Button
                    className={styles.viewAllQuestionsButton}
                    dataTn="questionsAnswers-viewAllQuestions"
                    href="/answers/"
                    type="secondaryAlt"
                    size="medium"
                >
                    <FormattedMessage
                        id="questionsAnsers.viewAllQuestions"
                        defaultMessage="View All Questions"
                    />
                </Button>
            </div>
        );
    }
    return null;
};

export const RelatedQuestions = createFragmentContainer(RelatedQuestionsComponent, {
    question: graphql`
        fragment RelatedQuestions_question on QuestionType {
            relatedQuestions {
                title
                url
                answerCount
            }
        }
    `,
});
